// $grid-breakpoints: (
//   xs: 0,
//   sm: 576px,
//   md: 768px,
//   lg: 992px,
//   xl: 1200px,
//   xxl: 1400px

export const BREAKPOINT_LG = 1200
export const BREAKPOINT_MD = 992
export const BREAKPOINT_SM = 768


export const PUBLIC_URL = process.env.PUBLIC_URL;

export const OPTION_DRAWER_FILL = 174;
export const OPTION_ADDITIONAL_MATTRESS = 837;

window['OPTION_DRAWER_FILL'] = OPTION_DRAWER_FILL;
window['OPTION_ADDITIONAL_MATTRESS'] = OPTION_ADDITIONAL_MATTRESS;